import OktaLoginCallback from './components/authentication/OktaLoginCallback';
import PageContainer from './components/pages/common/PageContainer';
import Top from './components/pages/MyM101_Top/Top';
import Home from './components/pages/MyM102_Home/Home';
import NewUserRegistration from './components/pages/MyM201_NewUserRegistration/NewUserRegistration';
import UserProfile from './components/pages/MyM202_UserProfile/UserProfile';
import UserList from './components/pages/MyM203_UserList/UserList';
import EmailDelivery from './components/pages/MyM206_EmailDelivery/EmailDelivery';
import ExcludeDestination from './components/pages/MyM207_ExcludeDestination/ExcludeDestination';
import NotificationManagement from './components/pages/MyM208_NotificationManagement/NotificationManagement';
import SalesLv1 from './components/pages/MyM301_SalesLv1/SalesLv1';
import SalesLv2 from './components/pages/MyM302_SalesLv2/SalesLv2';
import ServiceLv1 from './components/pages/MyM303_ServiceLv1/ServiceLv1';
import ServiceLv2 from './components/pages/MyM304_ServiceLv2/ServiceLv2';
import ITApplications from './components/pages/MyM305_ITApplications/ITApplications';
import SpecializedPartsServiceLv1 from './components/pages/MyM306_SpecializedParts&ServiceLv1/SpecializedParts&ServiceLv1';
import { SpecializedPartsServiceLv2SubLv1 } from './components/pages/MyM307_SpecializedParts&ServiceLv2_1/SpecializedParts&ServiceLv2_1';
import SpecializedPartsServiceLv2SubLv2 from './components/pages/MyM308_SpecializedParts&ServiceLv2_2/SpecializedParts&ServiceLv2_2';
import DigitalSolutionLv1 from './components/pages/MyM309_DigitalSolutionLv1/DigitalSolutionLv1';
import { DigitalSolutionLv2SubLv1 } from './components/pages/MyM310_DigitalSolutionLv2_1/DigitalSolutionLv2_1';
import DigitalSolutionLv2SubLv2 from './components/pages/MyM311_DigitalSolutionLv2_2/DigitalSolutionLv2_2';
import DigitalSolutionLv3 from './components/pages/MyM312_DigitalSolutionLv3/DigitalSolutionLv3';
import AHSLv1 from './components/pages/MyM313_AHSLv1/AHSLv1';
import AHSLv2SubLv1 from './components/pages/MyM314_AHSLv2_1/AHSLv2_1';
import AHSLv2SubLv2 from './components/pages/MyM315_AHSLv2_2/AHSLv2_2';
import AHSLv2SubLv3 from './components/pages/MyM316_AHSLv2_3/AHSLv2_3';
import TrainingLv1 from './components/pages/MyM317_TrainingLv1/TrainingLv1';
import TrainingLv2SubLv1 from './components/pages/MyM318_TrainingLv2_1/TrainingLv2_1';
import TrainingLv2SubLv2 from './components/pages/MyM319_TrainingLv2_2/TrainingLv2_2';
import TrainingLv2SubLv3 from './components/pages/MyM320_TrainingLv2_3/TrainingLv2_3';
import ServiceLv2SubLv2 from './components/pages/MyM321_ServiceLv2_2/ServiceLv2SubLv2';
import ServiceLv2SubLv3 from './components/pages/MyM322_ServiceLv2_3/ServiceLv2SubLv3';
import Marketing from './components/pages/MyM324_Marketing/Marketing';
import AssetLibrary from './components/pages/MyM325_AssetLibrary/AssetLibrary';
import ServiceLv3 from './components/pages/MyM323_ServiceLv3/ServiceLv3';
import SearchResultListView from './components/pages/MyM401_SearchResultListView/SearchResultListView';
import SearchResultThumbnailView from './components/pages/MyM402_SearchResultThumbnailView/SearchResultThumbnailView';
import NewsList from './components/pages/MyM501_NewsList/NewsList';
import NewsDetail from './components/pages/MyM502_NewsDetail/NewsDetail';
import NewsManagement from './components/pages/MyM503_NewsManagement/NewsManagement';
import FileManagement from './components/pages/MyM601_FileManagement/FileManagement';
import Support from './components/pages/MyM701_Support/Support';
import CookieAcceptance from './components/pages/MyM702_CookieAcceptance/CookieAcceptance';
import StepPage from './components/pages/MyM703_StapPage/StepPage';
import RequestHistory from './components/pages/MyM705_RequestHistory/RequestHistory';
import DirectContents from './components/pages/MyM707_DirectContents/DirectContents';
import FAQ from './components/pages/MyM708_FAQ/FAQ';
import AnswerSurvey from './components/pages/MyM801_AnswerSurvey/AnswerSurvey';
import SurveyResult from './components/pages/MyM802_SurveyResult/SurveyResult';
import SurveyManagement from './components/pages/MYM803_SurveyManagement/SurveyManagement';
import StandardPage from './components/pages/MyM903_StandardPage/StandardPage';
import TermsOfUse from './components/pages/MyM904_TermsOfUse/TermsOfUse';
import AccountActivated from './components/pages/MyM907_AccountActivated/AccountActivated';
import Help from './components/pages/MyM908_Help/Help';
import Error from './components/pages/MyM999_Error/Error';

export const MYMRoutes = [
  {
    element: <PageContainer />,
    children:
      [
        { path: '/', element: <Top /> },
        { path: '/login/callback', element: <OktaLoginCallback /> },
        {
          element: <StandardPage />,
          children:
            [
              { path: 'MyM102', element: <Home />, breadcrumb: 'lnkBreadcrumbsHome' },
              {
                path: 'MyM102',
                children:
                  [
                    { path: 'MyM202', element: <UserProfile /> },
                    { path: 'MyM301', element: <SalesLv1 />, breadcrumb: 'lnkBreadcrumbsSales' },
                    {
                      path: 'MyM301',
                      children:
                        [
                          { path: 'MyM302/:metadata_id', element: <SalesLv2 />, breadcrumb: ':context' },
                        ],
                    },
                    { path: 'MyM303', element: <ServiceLv1 />, breadcrumb: 'lnkBreadcrumbsService' },
                    {
                      path: 'MyM303',
                      children:
                        [
                          { path: 'MyM304/:metadata_id', element: <ServiceLv2 />, breadcrumb: ':context' },
                          // 2024.9.16 MyMine Version2.0対応 Add Start
                          { path: 'MyM321', element: <ServiceLv2SubLv2 />, breadcrumb: 'lnkBreadcrumbsPreDelivery' },
                          {
                            path: 'MyM321',
                            children:
                              [
                                { path: 'MyM317', element: <TrainingLv1 />, breadcrumb: 'lnkBreadcrumbsTrainingLv1' },
                                {
                                  path: 'MyM317',
                                  children:
                                    [
                                      { path: 'MyM318/:metadata_id', element: <TrainingLv2SubLv1 />, breadcrumb: ':context' },
                                      { path: 'MyM319/:metadata_id', element: <TrainingLv2SubLv2 />, breadcrumb: ':context' },
                                      { path: 'MyM320', element: <TrainingLv2SubLv3 />, breadcrumb: 'lnkBreadcrumbsTrainingLv2_3' },
                                    ],
                                },
                              ]
                          },
                          { path: 'MyM322', element: <ServiceLv2SubLv3 />, breadcrumb: 'lnkBreadcrumbsPostDelivery' },
                          {
                            path: 'MyM322',
                            children:
                              [
                                { path: 'MyM323/:metadata_id', element: <ServiceLv3 />, breadcrumb: ':context' },
                              ]
                          },
                          // 2024.9.16 MyMine Version2.0対応 Add End
                        ],
                    },
                    { path: 'MyM305', element: <ITApplications />, breadcrumb: 'lnkBreadcrumbsITApplications' },
                    // 2024.9.16 MyMine Version2.0対応 Add Start
                    { path: 'MyM306', element: <SpecializedPartsServiceLv1 />, breadcrumb: 'lnkBreadcrumbsSpecializedPartsServiceLv1' },
                    {
                      path: 'MyM306',
                      children:
                        [
                          { path: 'MyM307', element: <SpecializedPartsServiceLv2SubLv1 />, breadcrumb: 'lnkBreadcrumbsSpecializedPartsServiceLv2_1' },
                          { path: 'MyM308', element: <SpecializedPartsServiceLv2SubLv2 />, breadcrumb: 'lnkBreadcrumbsSpecializedPartsServiceLv2_2' },
                        ],
                    },
                    {
                      path: 'MyM309', element: <DigitalSolutionLv1 />, breadcrumb: 'lnkBreadcrumbsDigitalSolution'
                    },
                    {
                      path: 'MyM309',
                      children:
                        [
                          //2025.7.7 MyMine Version3.0対応 Modify Start
                          {
                            path: 'MyM310/:solution_name_lv2',
                            element: <DigitalSolutionLv2SubLv1 />, breadcrumb: 'lnkBreadcrumbsDigitalSolutionLv2_1',
                          },
                          {
                            path: 'MyM310/:solution_name_lv2/MyM312/:solution_name_lv3',
                            element: <DigitalSolutionLv3 />, breadcrumb: 'lnkBreadcrumbsDigitalSolutionLv3',
                          },
                          //2025.7.7 MyMine Version3.0対応 Modify End
                          {
                            path: 'MyM311/:solution_name_lv2',
                            element: <DigitalSolutionLv2SubLv2 />, breadcrumb: ':solution_name_lv2',
                          },
                          {
                            path: 'MyM311/:solution_name_lv2/MyM312/:solution_name_lv3',
                            element: <DigitalSolutionLv3 />, breadcrumb: ':solution_name_lv3'
                          },
                          {
                            path: 'MyM311/:solution_name_lv2/MyM312/:solution_name_lv3',
                            children:
                              [
                                { path: 'MyM302/:metadata_id', element: <SalesLv2 />, breadcrumb: ':context' },
                              ],
                          },
                          { path: 'MyM312/:solution_name_lv3', element: <DigitalSolutionLv3 />, breadcrumb: ':solution_name_lv3' },
                        ],
                    },
                    { path: 'MyM313', element: <AHSLv1 />, breadcrumb: 'lnkBreadcrumbsAHSLv1' },
                    {
                      path: 'MyM313',
                      children:
                        [
                          { path: 'MyM314', element: <AHSLv2SubLv1 />, breadcrumb: 'lnkBreadcrumbsAHSLv2_1' },
                          { path: 'MyM315', element: <AHSLv2SubLv2 />, breadcrumb: 'lnkBreadcrumbsAHSLv2_2' },
                          { path: 'MyM316', element: <AHSLv2SubLv3 />, breadcrumb: 'lnkBreadcrumbsAHSLv2_3' },
                        ],
                    },
                    { path: 'MyM317', element: <TrainingLv1 />, breadcrumb: 'lnkBreadcrumbsTrainingLv1' },
                    {
                      path: 'MyM317',
                      children:
                        [
                          { path: 'MyM318/:metadata_id', element: <TrainingLv2SubLv1 />, breadcrumb: ':context' },
                          { path: 'MyM319/:metadata_id', element: <TrainingLv2SubLv2 />, breadcrumb: ':context' },
                          { path: 'MyM320', element: <TrainingLv2SubLv3 />, breadcrumb: 'lnkBreadcrumbsTrainingLv2_3' },
                        ],
                    },
                    // 2025.7.7 MyMine Version3.0対応 Add Start
                    { path: 'MyM324', element: <Marketing />, breadcrumb: 'lnkBreadcrumbsMarketing' },
                    { path: 'MyM325', element: <AssetLibrary />, breadcrumb: 'lnkBreadcrumbsAssetLibrary'},
                    // 2025.7.7 MyMine Version3.0対応 Add End
                    // 2024.9.16 MyMine Version2.0対応 Add End
                    { path: 'MyM401', element: <SearchResultListView />, breadcrumb: 'lnkBreadcrumbsSearchResultListView' },
                    // 2024.5.8 MyMine Version1.5対応 Add Start
                    { path: 'MyM402', element: <SearchResultThumbnailView />, breadcrumb: 'lnkBreadcrumbsSearchResultThumbnailView' },
                    // 2024.5.8 MyMine Version1.5対応 Add End
                    { path: 'MyM501', element: <NewsList />, breadcrumb: 'lnkBreadcrumbsNewsList' },
                    // 2024.5.8 MyMine Version1.5対応 Add Start
                    {
                      path: 'MyM501',
                      children:
                        [
                          { path: 'MyM502/:news_id', element: <NewsDetail />, breadcrumb: ':context' },
                        ],
                    },
                    { path: 'MyM502/:news_id', element: <NewsDetail />, breadcrumb: ':context' },
                    // 2024.5.8 MyMine Version1.5対応 Add End
                    // 2025.7.7 MyMine Version3.0対応 Add Start
                    { path: 'MyM701', element: <Support />, breadcrumb: 'lnkBreadcrumbsSupport' },
                    { path: 'MyM708', element: <FAQ />, breadcrumb: 'lnkBreadcrumbsFAQ' },
                    // 2025.7.7 MyMine Version3.0対応 Add End
                  ],
              },
            ],
        },
        { path: 'MyM201', element: <NewUserRegistration /> },
        { path: 'MyM203', element: <UserList /> },
        // 2024.9.16 MyMine Version2.0対応 Add Start
        { path: 'MyM206', element: <EmailDelivery /> },
        { path: 'MyM207', element: <ExcludeDestination /> },
        { path: 'MyM208', element: <NotificationManagement /> },
        // 2024.9.16 MyMine Version2.0対応 Add End
        { path: 'MyM503', element: <NewsManagement /> },
        { path: 'MyM601', element: <FileManagement /> },
        { path: 'MyM702', element: <CookieAcceptance /> },
        { path: 'MyM703', element: <StepPage /> },
        // 2025.3.5 MyMine Version2.1対応 Add Start
        { path: 'MyM705', element: <RequestHistory /> },
        { path: 'MyM707/:encryptParam', element: <DirectContents /> },
        // 2025.3.5 MyMine Version2.1対応 Add End
        // 2024.9.16 MyMine Version2.0対応 Add Start
        { path: 'MyM801', element: <AnswerSurvey /> },
        { path: 'MyM802/:survey_id', element: <SurveyResult /> },
        { path: 'MyM803', element: <SurveyManagement /> },
        // 2024.9.16 MyMine Version2.0対応 Add End
        { path: 'MyM904', element: <TermsOfUse /> },
        { path: 'MyM907', element: <AccountActivated /> },
        { path: 'MyM908', element: <Help /> },
        { path: 'MyM999', element: <Error /> },
        { path: '*', element: <Error isNotFoundPage={true} /> },
      ]
  }
];

